import { AxiosResponse } from "axios";
import axiosInstance from "../../../../../interceptors/axiosInstance";

interface NumeroSolicitudResponse {
    result: number;
}

export async function getNumeroSolicitud(
    mutuoId: number
): Promise<AxiosResponse<NumeroSolicitudResponse>> {

    return axiosInstance.get<NumeroSolicitudResponse>("siscred-api-bandeja-mutuos/v1/mutuos/get",
        {
            params: { mutuoId }
        }
    );
}